module.exports = __webpack_public_path__ + "img/swxt.4341be6b.png";